import { Send } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { buildTelegramUrl, openTelegram } from "@/components/SocialFloat";

export function TelegramBanner() {
  const { settings } = useSettings();
  const tg = buildTelegramUrl(settings.telegram);
  if (!tg) return null;
  return (
    <div className="mx-auto max-w-6xl px-3 pt-3">
      <a href={tg} target="_blank" rel="noreferrer" onClick={(e) => openTelegram(e, tg)} data-testid="telegram-join-banner"
        className="live-fx group flex items-center gap-3 rounded-xl border-2 border-[#FFD700] px-4 py-3 shadow-md">
        <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-[#229ED9] text-white shadow ring-2 ring-white/70">
          <Send className="h-5 w-5" />
        </span>
        <span className="flex-1 leading-tight">
          <span className="block font-display text-base font-extrabold text-white sm:text-lg">Join Telegram Channel</span>
          <span className="block text-xs font-semibold text-white/90 sm:text-sm">Every result first — free live alerts</span>
        </span>
        <span data-testid="telegram-join-banner-btn" className="shrink-0 rounded-full bg-[#229ED9] px-4 py-2 text-sm font-extrabold text-white shadow transition-transform group-hover:scale-105">
          JOIN
        </span>
      </a>
    </div>
  );
}

export function TelegramFloat() {
  const { settings } = useSettings();
  const tg = buildTelegramUrl(settings.telegram);
  if (!tg) return null;
  return (
    <a href={tg} target="_blank" rel="noreferrer" onClick={(e) => openTelegram(e, tg)} data-testid="telegram-join-float" aria-label="Join Telegram Channel"
      className="fixed bottom-40 right-4 z-40 grid h-12 w-12 place-items-center rounded-full bg-[#229ED9] text-white shadow-lg ring-2 ring-white/60 transition-transform hover:scale-110 md:bottom-20">
      <Send className="h-6 w-6" />
    </a>
  );
}
